import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Buffer } from 'buffer';

const elements = document.querySelectorAll('[data-dynamic-news-params]')

elements.forEach(block => {
  const root = ReactDOM.createRoot(block as HTMLElement);

  const params = JSON.parse( Buffer.from( block.getAttribute( 'data-dynamic-news-params' ) as string, 'base64' ).toString());

  root.render(
    <React.StrictMode>
      <App params={ params } />
    </React.StrictMode>
  );
});
